import { CTPAT,CTPAT_SECTIONS_TO_VALIDATE } from './surveyLiterals'

const ctpatValidator = (question,section,answers,questionsToValidate) => {
    let required = undefined;//This value will return if the question does not enter in the if and it will take value of the DB

    if(CTPAT_SECTIONS_TO_VALIDATE.includes(section.code) && question.text !== 'Comments'){
        for(let item of questionsToValidate){
            let ansQuestion = answers.find(q => parseInt(q.questionId) === parseInt(item.id));
            if(ansQuestion){
                if(ansQuestion.answer === '1'){//YES
                    required = false;
                    break;
                }else{
                    required = true;
                }
            }
        }
    }
    return required;
}

const defaultValidator = () => {
    //console.log('default validator.....');
    return null;
}

export const getValidator = (code) => {
    let validator = null;

    switch (code) {
        case CTPAT:
            validator = ctpatValidator;
            break;      
        default:
            validator = defaultValidator
      }
    return validator;
}